import React, { useState, useEffect } from 'react';
import { Box, Collapse, Grid, Paper, Tooltip } from '@mui/material';
import ExpandMore from '../../../assets/icons/svg/flaticons/fi-sr-caret-up.svg';
import ExpandLess from '../../../assets/icons/svg/flaticons/fi-sr-caret-down.svg';
import './SCUICollapsiblePaper.scss';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

// Import common icons to avoid dynamic imports
import CopyIcon from '../../../assets/icons/svg/flaticons/fi-rr-copy.svg';

// Icon mapping to avoid dynamic imports
const iconMap: { [key: string]: string } = {
    'fi-rr-copy': CopyIcon,
};

export const SCUICollapsiblePaper = (props: any) => {
    const [open, setOpen] = React.useState(props.open === false ? false : true);
    const darkModeStore: any = useSelector((state: any) => state?.darkMode);
    const [darkState, setDarkState] = useState(darkModeStore?.isDarkMode);
    useEffect(() => {
        setDarkState(darkModeStore?.isDarkMode);
    }, [darkModeStore?.isDarkMode]);

    const handleClick = () => {
        setOpen(!open);
        if (props.onClick) {
            props.onClick(!open);
        }
    };
    const iconOnClick = () => {
        setOpen(true);
        if (props.iconOnClick) {
            props.iconOnClick();
        }
    };
    const { t } = useTranslation();
    return (
        <Grid container direction="row">
            <Grid
                size={{
                    lg: 12,
                    md: 12,
                    xs: 12,
                }}
            >
                <h1 className="headtxt">{props.title} </h1>
            </Grid>
            <Paper
                className={`collapsePaperMainPaper ${props.withoutMargin ? '' : 'collapsePaperMargin'}`}
                sx={{
                    bgcolor: !darkState
                        ? open
                            ? props.changeColorWhenOpen
                                ? '#FDFBF4'
                                : '#fff'
                            : '#fff'
                        : '#1e1e1e',
                }}
            >
                <Grid container direction="row">
                    {props.icon && props.icon.includes('fi-') && (
                        <Grid
                            size={{
                                xs: 1,
                            }}
                        >
                            <Tooltip title={props.iconTooltip}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        '& img': {
                                            width: '24px !important',
                                            height: '24px !important',
                                            maxWidth: '24px !important',
                                            maxHeight: '24px !important',
                                        },
                                    }}
                                >
                                    <img
                                        alt=""
                                        src={iconMap[props.icon] || CopyIcon}
                                        className={`flatIcon ${darkState ? 'darkModeFlatImg' : 'lightModeFlatImg'}`}
                                        onClick={iconOnClick}
                                        onError={(e) => {
                                            console.error('Image failed to load:', props.icon);
                                            e.currentTarget.style.display = 'none';
                                        }}
                                    />
                                </Box>
                            </Tooltip>
                        </Grid>
                    )}
                    <Grid
                        size={{
                            xs: 10,
                        }}
                    >
                        {props.paperText ? props.paperText : t('general.filter')}
                    </Grid>
                    {!open ? (
                        <Grid
                            size={{
                                xs: 0.5,
                            }}
                        >
                            <img
                                src={ExpandLess}
                                alt="expand less"
                                width="24px"
                                height="24px"
                                className={`floatRight ${darkState ? 'darkModeFlatImg' : 'lightModeFlatImg'}`}
                                onClick={handleClick}
                            />
                        </Grid>
                    ) : (
                        <Grid
                            size={{
                                xs: 0.5,
                            }}
                        >
                            <img
                                src={ExpandMore}
                                alt="expand more"
                                width="24px"
                                height="24px"
                                className={`floatRight ${darkState ? 'darkModeFlatImg' : 'lightModeFlatImg'}`}
                                onClick={handleClick}
                            />
                        </Grid>
                    )}
                </Grid>
                <br />
                <Collapse in={open} timeout="auto" unmountOnExit>
                    {props.children}
                </Collapse>
            </Paper>
        </Grid>
    );
};
